import styled, { css } from "styled-components";

const ButtonContent = styled.span`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.5rem 1rem;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-bottom: 0.8em;
  font-size: 1.6em;
`;

const sizes = {
  small: css`
    font-size: 1.2rem;
    padding: 0.4rem 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
  `,
  medium: css`
    margin-top: 1rem;
    font-size: 1.4rem;
    padding: 1.2rem 1.6rem;
    font-weight: 500;
  `,
  large: css`
    font-size: 1.6rem;
    padding: 1.2rem 2.4rem;
    font-weight: 500;
    width: 25rem;
    height: 8rem;
  `,
};

const variations = {
  primary: css`
    color: var(--color-brand-50);
    background-color: var(--color-brand-600);

    &:hover {
      background-color: var(--color-brand-700);
    }
  `,
  secondary: css`
    color: var(--color-grey-600);
    background: var(--color-grey-0);
    border: 1px solid var(--color-grey-200);

    &:hover {
      background-color: var(--color-grey-50);
    }
  `,
  danger: css`
    color: var(--color-red-100);
    background-color: var(--color-red-700);

    &:hover {
      background-color: var(--color-red-800);
    }
  `,
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-grey-900);
  padding: 1.4em 0.8em;
  font-size: 0.9em;
  min-width: 12rem;
  white-space: nowrap;
  border-radius: 1.5em;
  background: #26262c;
  border: 1px solid #101011;
  transition: all 0.3s;
  box-shadow: -1px -2px 2px #1a1a1e, 0.2px 3px 1px #4d4d52;
  ${(props) => sizes[props.$size]}
  ${(props) => variations[props.$variation]}

  &:active {
  }
`;

const ButtonMenu = ({ icon, children, ...props }) => {
  return (
    <Button {...props}>
      <ButtonContent>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        {children}
      </ButtonContent>
    </Button>
  );
};

export default ButtonMenu;
